"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currency = void 0;
var currency = function (value, addPlus, noIndicator) {
    if (addPlus === void 0) { addPlus = false; }
    if (noIndicator === void 0) { noIndicator = false; }
    if (!Number.isFinite(value)) {
        return '';
    }
    var positiveIndicator = addPlus ? '+ ' : '';
    var withIndicator = value < 0 ? '- ' : positiveIndicator;
    var indicator = noIndicator ? '' : withIndicator;
    return "".concat(indicator, "$").concat(Math.round(Math.abs(value)).toLocaleString());
};
exports.currency = currency;
